import { Colors } from '@arboxappv4/shared/src/styles/Colors';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Progress } from 'antd';
import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import CustomModal from '../../../components/UI/CustomModal';
import { FlexColumnSection, GreyText, SmallHeader } from '../../../styles/globalStyles';

const RedirectLoader = props => {
  const { isOpen, redirectLink } = props;
  const [animatedProgress, setAnimatedProgress] = useState(0);

  useEffect(() => {
    if (!isOpen) {
      setAnimatedProgress(0);
      return;
    }
    setAnimatedProgress(0);
    const interval = setInterval(() => {
      setAnimatedProgress(prev => {
        if (prev >= 90) {
          clearInterval(interval);
          // window.location.href = redirectLink;
          return 90;
        }
        return prev + 1;
      });
    }, 15);
    return () => clearInterval(interval);
  }, [isOpen]);

  return (
    <CustomModal open={isOpen} onClose={() => null} closable={false} width="400px">
      <FlexColumnSection gap="20px" align="center" style={{ padding: '24px 8px' }}>
        <CheckCircle>
          <FontAwesomeIcon icon={light('check')} size="lg" />
        </CheckCircle>
        <FlexColumnSection gap="8px" align="center" flex="none">
          <SmallHeader style={{ textAlign: 'center', fontWeight: 500 }}>
            {t('payment-successful')}
          </SmallHeader>
          <GreyText style={{ textAlign: 'center' }}>{t('transaction-completed')}</GreyText>
        </FlexColumnSection>
        <Progress
          percent={animatedProgress}
          showInfo={false}
          strokeColor={Colors.siteBlack}
          railColor={Colors.siteScheduleBorder}
          size={['100%', 3]}
        />
        <GreyText style={{ textAlign: 'center', fontWeight: 500 }}>
          {t('redirecting-to-page')}
        </GreyText>
      </FlexColumnSection>
    </CustomModal>
  );
};

export default RedirectLoader;

const CheckCircle = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: 2px solid ${Colors.siteBlack};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: ${Colors.siteBlack};
`;
